import React from "react";
import { VerticalNavigationWrapper } from "./Styled";
import Icon from "../../../shared/svg/VerticalNavigationIcon";
import IconButton from "../../../shared/components/IconButton";

const VerticalNavigation = ({
    setIsCollapsed,
}: {
    setIsCollapsed: Function;
}) => {
    return (
        <VerticalNavigationWrapper>
            <IconButton
                onClick={() => setIsCollapsed((prev: boolean) => !prev)}
            >
                <Icon defaultColor="black" selectedColor="black" isSelected />
            </IconButton>
        </VerticalNavigationWrapper>
    );
};

export default VerticalNavigation;
